"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADMIN_URLS = void 0;
var ADMIN_URLS = ['http://localhost:3002', 'https://dev-admin.abroad.io', 'https://rc-admin.abroad.io', 'https://admin.abroad.io'];
exports.ADMIN_URLS = ADMIN_URLS;